<script setup>
defineProps({
  peleador: { type: Object, required: true },
  obtenerColorCinta: { type: Function, required: true },
  obtenerNombreCinta: { type: Function, required: true },
});
</script>

<template>
  <div class="fcard">
    <img :src="peleador.imagen" :alt="peleador.nombre" class="fcard-img" />
    <div class="fcard-overlay"></div>

    <div class="fcard-body">
      <span class="fcard-equipo">{{ peleador.equipo }}</span>
      <h3 class="fcard-nombre">{{ peleador.nombre }}</h3>

      <div class="fcard-meta">
        <div class="cinta" :style="{ '--c': obtenerColorCinta(peleador.cinta) }">
          <span class="cinta-cuerpo">{{ obtenerNombreCinta(peleador.cinta) }}</span>
          <span
            class="cinta-tip"
            :class="peleador.cinta === 'negra' ? 'tip-roja' : 'tip-negra'"
          ></span>
        </div>
        <!-- <span v-if="peleador.edad" class="fcard-edad">{{ peleador.edad }} años</span> -->
      </div>

      <div class="fcard-footer">
        <div class="socials">
          <a v-if="peleador.instagram" :href="peleador.instagram" target="_blank">
            <img src="@/assets/img/Evolve/instagram.png" alt="IG" />
          </a>
          <a v-if="peleador.facebook" :href="peleador.facebook" target="_blank">
            <img src="@/assets/img/Evolve/facebook.png" alt="FB" />
          </a>
          <a v-if="peleador.youtube" :href="peleador.youtube" target="_blank">
            <img src="@/assets/img/Evolve/youtube.png" alt="YT" />
          </a>
          <a v-if="peleador.twitter" :href="peleador.twitter" target="_blank">
            <img src="@/assets/img/Evolve/twitter.png" alt="TW" />
          </a>
        </div>
        <div v-if="peleador.bandera" class="bandera">
          <img :src="peleador.bandera" :alt="peleador.nombre" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fcard {
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  background: #07101a;
  border: 1px solid rgba(255, 255, 255, 0.07);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.65);
  transition: box-shadow 0.35s ease;
  cursor: default;
  width: 100%;
  height: 100%;
}
.fcard:hover {
  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(0, 170, 255, 0.18);
}
.fcard-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  transition: transform 0.7s cubic-bezier(0.2, 1, 0.3, 1);
}
.fcard:hover .fcard-img {
  transform: scale(1.05) translateY(-6px);
}
.fcard-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.95) 0%,
    rgba(0, 0, 0, 0.55) 35%,
    rgba(0, 0, 0, 0.1) 60%,
    transparent 80%
  );
}
.fcard-body {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 20px 18px;
  z-index: 5;
}
.fcard-equipo {
  display: block;
  font-size: 0.6rem;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #00aaff;
  font-weight: 700;
  margin-bottom: 3px;
  opacity: 0.85;
}
.fcard-nombre {
  font-family: "Oswald", "Impact", sans-serif;
  font-size: 1.45rem;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  line-height: 1.1;
  margin: 0 0 12px;
  letter-spacing: 0.3px;
}
.fcard-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.fcard-edad {
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* ── Cinta ── */
.cinta {
  display: inline-flex;
  align-items: stretch;
  height: 19px;
  border-radius: 3px;
  overflow: visible;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}
.cinta-cuerpo {
  background-color: var(--c, #888);
  display: flex;
  align-items: center;
  padding: 0 8px;
  font-size: 0.52rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.75);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
  white-space: nowrap;
}
.cinta-tip {
  width: 32px;
  height: 100%;
  border-left: 1px solid rgba(0, 0, 0, 0.35);
  flex-shrink: 0;
}
.tip-negra {
  background: #111;
}
.tip-roja {
  background: #8b0000;
}

.fcard-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.socials {
  display: flex;
  gap: 9px;
}
.socials a img {
  width: 24px;
  height: 24px;
  filter: brightness(0.65);
  transition: filter 0.2s, transform 0.2s;
}
.socials a:hover img {
  filter: brightness(1) drop-shadow(0 0 5px rgba(0, 170, 255, 0.55));
  transform: translateY(-3px);
}
.bandera {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  border: 1.5px solid rgba(255, 255, 255, 0.55);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  flex-shrink: 0;
}
.bandera img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
